import React, { useState } from "react";
import { ReactComponent as RaceSportIcon } from '../../assets/race-flag.svg';

import { getUrlToFetch } from '../../data/utils/getUrlToFetch';
import { getAccountIds } from '../../data/utils/getAccountIds';
import { getConfiguration } from '../../data/utils/configuration';
import { concatUrlPathnames } from "../../data/sport-utils";
import { useFetch } from "../../data/fetch/useFetch";
import { systemCode } from "../..";
import { getLabel } from "../../data/labels";

export default function RaceSportButton(props) {
    const conf = getConfiguration();
    const [isRaceActive,setIsRaceActive] = useState(false);
    const numConto = getAccountIds()?.split(";")?.[1] || '';
    let hrefLink = '/xcasinoracesport';

    try {
        if(typeof window.cg_SEO_URL_MAPPING_REVERSE != 'undefined') {
            hrefLink = concatUrlPathnames('/',JSON.parse(window.cg_SEO_URL_MAPPING_REVERSE)['xcasinoracesport']);
        }
    }catch(err) {
        console.error(err);
    }

    const [isLoading, isError, data] = useFetch(getUrlToFetch(conf.xrc?.url), {
        system_code: systemCode,
        num_conto: numConto,
        skipBaseParams: true
    }, (data) =>{
        try {
            if(parseInt(data?.raceAttiva) > 0 && !isRaceActive){
                setIsRaceActive(true);
            }
        }catch(err) {
            if(isRaceActive) {
                setIsRaceActive(false);
            }
            console.error(err);
        }
    },
    conf.xrc?.enabled? true: false  
    );

    return (isRaceActive &&
        <>
             <a href={hrefLink} className="xsport-race-sport-icon-container shrink-0 h-[50px] grid grid-cols-12 items-center border-y border-y-cs7">
                <div className="xsport-race-sport-icon xs-sport-icon col-start-1 col-end-3 justify-self-center inline-block w-[24px] h-[24px]">
                <RaceSportIcon />
                </div>
                <div className="col-start-3 col-end-11 font-medium text-sm text-cs-3">{getLabel('race_sport.title', 'Race Sport')}</div>
            </a>
        </>
    )
}